import { useState } from 'react';
import { format } from 'date-fns';
import Loading from '@/components/general/Loading';
import useApiFetch from '@/hooks/useApiFetch';
import checkinReports, { GetCheckinsReport } from '@/services/checkinReports';
import { FetchApiIds } from '@/types';
import { ResponseGetCheckinsReport, ResponseGetPulseReport } from '@/types/api';
import { DatePeriodFilters, getFilterPeriodDates } from '@/utils/charts';
// import { getArrayIntoStringByProp } from '@/utils/format';
import CheckinsReportPage from './CheckinsReport.component';

const CheckinsReportContainer = function (): JSX.Element {
  const [currentDateFilter, setCurrentDateFilter] = useState(DatePeriodFilters.SIX_MONTHS);
  const [periodFilterToQuery, setPeriodFilterToQuery] = useState(() => {
    const { startDateFormattedToQuery: start, endDateFormattedToQuery: end } = getFilterPeriodDates(
      DatePeriodFilters.SIX_MONTHS
    );

    return { start, end };
  });

  // const [selectedUsers, setSelectedUsers] = useState<User[]>([]);
  // const [selectedUserIdsToQuery, setSelectedUserIdsToQuery] = useState<string | undefined>();

  const getPulsesResponse = useApiFetch<ResponseGetPulseReport, GetCheckinsReport>(
    [
      FetchApiIds.AVERAGE_PULSES,
      periodFilterToQuery.start,
      periodFilterToQuery.end,
      // selectedUserIdsToQuery,
    ],
    async () =>
      checkinReports.getAveragePulses({
        // userIds: selectedUserIdsToQuery,
        startDate: periodFilterToQuery.start,
        endDate: periodFilterToQuery.end,
      }),
    {
      enabled: !!periodFilterToQuery.start && !!periodFilterToQuery.end,
    }
  );

  const getCheckinsReportResponse = useApiFetch<ResponseGetCheckinsReport, GetCheckinsReport>(
    [
      FetchApiIds.CHECKIN_REPORTS,
      periodFilterToQuery.start,
      periodFilterToQuery.end,
      // selectedUserIdsToQuery,
    ],
    async () =>
      checkinReports.getCheckinsReport({
        // userIds: selectedUserIdsToQuery,
        startDate: periodFilterToQuery.start,
        endDate: periodFilterToQuery.end,
      }),
    {
      enabled: !!periodFilterToQuery.start && !!periodFilterToQuery.end,
    }
  );

  const handleChangeDateFilter = (datePeriod: DatePeriodFilters): void => {
    const { startDateFormattedToQuery: start, endDateFormattedToQuery: end } =
      getFilterPeriodDates(datePeriod);

    setCurrentDateFilter(datePeriod);
    setPeriodFilterToQuery({ start, end });
  };

  const handleChangeCustomDateFilter = (startDate?: Date, endDate?: Date): void => {
    const startDateFormattedToQuery = startDate
      ? format(startDate, 'yyyy-MM-dd')
      : periodFilterToQuery.start;
    const endDateFormattedToQuery = endDate
      ? format(endDate, 'yyyy-MM-dd')
      : periodFilterToQuery.end;

    setCurrentDateFilter(DatePeriodFilters.CUSTOM_DATE);
    setPeriodFilterToQuery({ start: startDateFormattedToQuery, end: endDateFormattedToQuery });
  };

  // const handleSetUsersToFilter = (members: User[]): void => {
  //   setSelectedUsers(members);
  // };

  // useEffect(() => {
  //   if (selectedUsers.length > 0) {
  //     const selectedUserIds = getArrayIntoStringByProp<User>({
  //       array: selectedUsers,
  //       propName: 'id',
  //       withSpace: false,
  //     });

  //     setSelectedUserIdsToQuery(selectedUserIds);
  //   } else {
  //     setSelectedUserIdsToQuery(undefined);
  //   }
  // }, [selectedUsers]);

  const isPageLoadingWithoutSelectedUsers =
    // (getPulsesResponse.isLoading || getCheckinsReportResponse.isLoading) && !selectedUserIdsToQuery;
    getPulsesResponse.isLoading || getCheckinsReportResponse.isLoading;

  if (isPageLoadingWithoutSelectedUsers) return <Loading fullPage />;

  return (
    <CheckinsReportPage
      pulseReport={getPulsesResponse?.data?.pulse}
      checkinsReport={getCheckinsReportResponse?.data?.submittedCheckIns}
      currentDateFilter={currentDateFilter}
      periodFilterInterval={periodFilterToQuery}
      handleChangeDateFilter={handleChangeDateFilter}
      handleChangeCustomDateFilter={handleChangeCustomDateFilter}
      // handleSetUsersToFilter={handleSetUsersToFilter}
      // selectedUsers={selectedUsers}
    />
  );
};

export default CheckinsReportContainer;
